// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardTextTileToolbarConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

export default {
  get BUTTON_STYLE() {
    return {
      get bold() {
        return {
          className: 'u_textBold',
          title: localizer.getText('FONT_STYLE_BOLD_TOOLTIP'),
          value: 'bold',
          text: 'B',
          isExecute: true
        };
      },
      get italic() {
        return {
          className: 'u_textItalic',
          title: localizer.getText('FONT_STYLE_ITALIC_TOOLTIP'),
          value: 'italic',
          text: 'I',
          isExecute: true
        };
      },
      get underline() {
        return {
          className: 'u_textUnderline',
          title: localizer.getText('FONT_STYLE_UNDERLINE_TOOLTIP'),
          value: 'underline',
          text: 'U',
          isExecute: true
        };
      },
      get strikethrough() {
        return {
          className: 'icon-del-text',
          title: localizer.getText('COMMON_LABEL_STRIKETHROUGH'),
          value: 'strikethrough',
          isExecute: true
        };
      }
    };
  },
  get BUTTON_ALIGN() {
    return {
      get alignleft() {
        return {
          className: 'icon-align-left',
          title: localizer.getText('COMMON_LABEL_ALIGN_LEFT'),
          value: 'JustifyLeft',
          isExecute: true
        };
      },
      get aligncenter() {
        return {
          className: 'icon-align-center',
          title: localizer.getText('COMMON_LABEL_ALIGN_CENTER'),
          value: 'JustifyCenter',
          isExecute: true
        };
      },
      get alignright() {
        return {
          className: 'icon-align-right',
          title: localizer.getText('COMMON_LABEL_ALIGN_RIGHT'),
          value: 'JustifyRight',
          isExecute: true
        };
      },
      get alignjustify() {
        return {
          className: 'icon-align-justify',
          title: localizer.getText('COMMON_LABEL_ALIGN_JUSTIFY'),
          value: 'JustifyFull',
          isExecute: true
        };
      }
    };
  },
  get BUTTON_ALIGN_VERTICAL() {
    return {
      get alignTop() {
        return {
          className: 'icon-align-top',
          title: localizer.getText('COMMON_LABEL_TOP'),
          value: 'alignTop'
        };
      },
      get alignMiddle() {
        return {
          className: 'icon-align-middle',
          title: localizer.getText('COMMON_LABEL_MIDDLE'),
          value: 'alignMiddle'
        };
      },
      get alignBottom() {
        return {
          className: 'icon-align-bottom',
          title: localizer.getText('COMMON_LABEL_BOTTOM'),
          value: 'alignBottom'
        };
      }
    };
  },
  get BUTTON_LIST() {
    return {
      get bullet() {
        return {
          type: 'bullet',
          component: require('modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.IconDropdownSetting'),
          className: 'icon-list-bullet',
          title: localizer.getText('COMMON_LABEL_BULLET_LIST')
        };
      },
      get numbered() {
        return {
          type: 'numbered',
          component: require('modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.IconDropdownSetting'),
          className: 'icon-numbered',
          title: localizer.getText('COMMON_LABEL_NUMBERED_LIST')
        };
      }
    };
  },
  get BUTTON_INDENT() {
    return {
      get indent() {
        return {
          className: 'icon-cl',
          title: localizer.getText('DASHBOARD_TEXT_TITLE_TOOLBAR_CONSTANTS_INCREASE_INDENT'),
          value: 'Indent',
          isExecute: true
        };
      },
      get outdent() {
        return {
          className: 'icon-ex',
          title: localizer.getText('DASHBOARD_TEXT_TITLE_TOOLBAR_CONSTANTS_DECREASE_INDENT'),
          value: 'Outdent',
          isExecute: true
        };
      }
    };
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.DashboardTextTileToolbarConstants.js